module.exports = __webpack_public_path__ + "img/4.40d5bd6a.png";